var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNullifyDataBluish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H16.3704V2.51852H0V0ZM0 5.03704H16.3704V7.55556H0V5.03704ZM6.92578 10.0741H0V12.5926H6.92578V10.0741Z",
    fill: "#8DABC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4941 10.2559C18.7635 10.0164 18.7635 9.59527 18.4941 9.35573C18.2659 9.15291 17.9221 9.15291 17.6939 9.35573L15.1648 11.6038C14.7859 11.9406 14.2149 11.9406 13.836 11.6038L11.3069 9.35573C11.0787 9.15291 10.7349 9.15291 10.5067 9.35573C10.2373 9.59527 10.2373 10.0164 10.5067 10.2559L12.7531 12.2527C13.2007 12.6505 13.2007 13.3497 12.7531 13.7475L10.5067 15.7443C10.2373 15.9838 10.2373 16.4049 10.5067 16.6445C10.7349 16.8473 11.0787 16.8473 11.3069 16.6445L13.836 14.3964C14.2149 14.0596 14.7859 14.0596 15.1648 14.3964L17.6939 16.6445C17.9221 16.8473 18.2659 16.8473 18.4941 16.6445C18.7635 16.4049 18.7635 15.9838 18.4941 15.7443L16.2477 13.7475C15.8001 13.3497 15.8001 12.6505 16.2477 12.2527L18.4941 10.2559Z",
    fill: "#8DABC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullifyDataBluish);
export default __webpack_public_path__ + "static/media/nullifyData_bluish.489fdd719523a2c8680f84d164cb8d4d.svg";
export { ForwardRef as ReactComponent };